var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artist, count, publishedAt) {
buf.push("<div class=\"notifications-list-item\"><a" + (jade.attr("href", artist.href(), true, true)) + " class=\"notifications-artist-link\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a><span class=\"notifications-publish-date\">" + (jade.escape(null == (jade_interp = publishedAt) ? "" : jade_interp)) + "</span><div class=\"notifications-works-added\">" + (jade.escape(null == (jade_interp = count + ' ') ? "" : jade_interp)));
if ( count == 1)
{
buf.push("work added");
}
else
{
buf.push("works added");
}
buf.push("</div><div class=\"notifications-published-artworks\"></div><div class=\"notifications-see-more\"><a" + (jade.attr("href", artist.href() + '?sort=-published_at', true, true)) + ">See More</a></div></div>");}.call(this,"artist" in locals_for_with?locals_for_with.artist:typeof artist!=="undefined"?artist:undefined,"count" in locals_for_with?locals_for_with.count:typeof count!=="undefined"?count:undefined,"publishedAt" in locals_for_with?locals_for_with.publishedAt:typeof publishedAt!=="undefined"?publishedAt:undefined));;return buf.join("");
};
module.exports = template;